import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';
import s from '../../IconV2.scss';

const Close24: FC<IconV2Props> = ({ icon, chroma, className }) => (
  <svg
    className={cn(
      chroma === 'light' ? s.svgLight24 : s.svgDark24,
      `svg-icon--${icon}`,
      className
    )}
    width="24"
    height="24"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={`${icon}-24`}
  >
    <path
      d="M16.088 7 17 8.103l-3.98 3.896L17 15.897 16.088 17l-4.085-4.003L12 13l-.003-.003L7.912 17 7 15.897 10.979 12 7 8.103 7.912 7l4.086 4.002L12 11l.002.002L16.088 7Z"
      fill="#000"
      fillRule="nonzero"
    />
  </svg>
);

export default Close24;
